<div class="app-container">
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  <form [formGroup]="companySettingsForm" (ngSubmit)="updateCompany()" *ngIf="company">
    <page-header
      [title]="'company.settings'"
      [appendNoTranslationTitlePart]="company ? company.name : ''"
      [icon]="'far-cog'"
    >
      <ng-container class="header-button">
        <btn
          [label]="'save'"
          [title]="'save' | translate"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-check'"
          [btnType]="'submit'"
          [isLoading]="loading"
          [spinnerClassesString]="'spinner-white'"
          [btnDisabled]="loading"
          data-cy="edit-company"
        ></btn>
      </ng-container>
    </page-header>

    <section class="content">
      <div class="card">
        <div class="row">
          <div class="col-sm-6">
            <form-row-input
              [label]="'email'"
              [icon]="null"
              [formGroup]="companySettingsForm"
              formControlName="email"
              [required]="
                companySettingsForm.get('email').errors !== null && companySettingsForm.get('email').errors.required
              "
              [requiredCssClass]="submitted && formControls.email.errors"
              data-cy="email"
            ></form-row-input>
            <form-row-input
              [label]="'phone'"
              [icon]="null"
              [formGroup]="companySettingsForm"
              formControlName="phone"
              data-cy="phone"
            >
            </form-row-input>
            <form-row-select
              [label]="'company.batch-expiration'"
              [options]="batchExpirationOptions"
              [icon]="null"
              [formGroup]="companySettingsForm"
              formControlName="batchExpiration"
              [optionKey]="'code'"
              [dataCyAttribute]="'company-batch-expiration'"
            >
            </form-row-select>
            <form-row-select
              [label]="'company.enabledPositions'"
              [options]="positionsOptions"
              [icon]="null"
              [formGroup]="companySettingsForm"
              formControlName="enabledPositions"
              [optionKey]="'code'"
              [dataCyAttribute]="'company-positions'"
            >
            </form-row-select>
          </div>
        </div>
      </div>
    </section>
  </form>
  <!--  <btn-->
  <!--    *ngIf="canStartPlugNPlayProcess"-->
  <!--    [label]="'company.plug-play'"-->
  <!--    [title]="'company.plug-play' | translate"-->
  <!--    [classes]="['btn-first', 'float-right']"-->
  <!--    [routerLink]="'/plugplay/step-1'"-->
  <!--  ></btn>-->
</div>
